import { Component, input } from '@angular/core';

@Component({
  selector: 'ia-report-technical-problem-field-error',
  template: `
    @if (show()) {
      <p class="tw-text-sm tw-font-semibold tw-text-red-600" role="alert">
        {{ message() }}
      </p>
    }
  `,
  imports: [],
})
export class FieldErrorComponent {
  public readonly show = input(false);
  public readonly message = input<string>();
}
